import React from 'react'
import {MenuItem} from '../../webui/inputs/MenuItem'
import {Select, SelectChangeEvent, SelectInputProps} from '../../webui/inputs/Select'
import {LoadingSpinnerContainer} from '../../webui/progress/LoadingSpinnerContainer'
import {useAllProducts} from './gql/useAllProducts'
import {sortProducts} from './utils/sortProducts'

export interface ProductSelectProps {
  id: string
  value: string
  onChange: (value: string, event: SelectChangeEvent<string>) => void
}

const NO_PRODUCT_VALUE = '__no_product__'

interface ProductItem {
  label: string
  value: string
}

export const ProductSelect: React.FC<ProductSelectProps> = ({id, onChange, value}) => {
  const {data: products, loading, error} = useAllProducts()

  if (loading) {
    return <LoadingSpinnerContainer />
  }
  if (error) {
    return <div>{error.message}</div>
  }

  const productItems: ProductItem[] = sortProducts(products).map((product) => ({
    label: product.name,
    value: product.id,
  }))

  const onProductChange: SelectInputProps<string>['onChange'] = (event) => {
    const nextValue = event.target.value === NO_PRODUCT_VALUE ? '' : (event.target.value as string)
    onChange(nextValue, event)
  }

  return (
    <Select label={'Product'} id={id} value={value === '' ? NO_PRODUCT_VALUE : value} onChange={onProductChange}>
      <MenuItem value={NO_PRODUCT_VALUE}>No product</MenuItem>
      {productItems.map((product) => (
        <MenuItem key={product.value} value={product.value}>
          {product.label}
        </MenuItem>
      ))}
    </Select>
  )
}
